/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSimulationEffectDateQuery = gql`
  query GetSimulationEffectDateQuery {
    getSimulationEffectDate_simulation_effect_date {
      effectDate 
      minEffectDate 
      maxEffectDate 
      displayEffectDateError 
      offerCode 
      contractOnGoing 
    }
  }
`;

export default GetSimulationEffectDateQuery;
